import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Hero3D from "../Hero3D";
import Reveal from "../Reveal";
import { useT } from "../../i18n/I18nProvider";

export const HomeHero = () => {
  const t = useT();

  return (
    <section className="relative overflow-hidden">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 pt-12 md:pt-24 pb-20 md:pb-40 grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7 relative z-10">
          <Reveal>
            <div className="overline mb-6 md:mb-8" data-testid="hero-overline">
              {t("home.hero.overline")}
            </div>
          </Reveal>
          <Reveal delay={80}>
            <h1
              className="font-display text-[16vw] sm:text-[12vw] lg:text-[8.2vw] leading-[0.92] tracking-tightest text-ink-900"
              data-testid="hero-title"
            >
              {t("home.hero.title1")}{" "}
              <span className="font-editorial text-ink-700">
                {t("home.hero.titleEditorial")}
              </span>
              <br />
              {t("home.hero.title2")}
              <br />
              {t("home.hero.title3")}
            </h1>
          </Reveal>
          <Reveal delay={180}>
            <p className="mt-6 md:mt-10 max-w-xl text-[15px] md:text-[17px] text-ink-500 leading-relaxed">
              {t("home.hero.paragraph")}
            </p>
          </Reveal>
          <Reveal delay={260}>
            <div className="mt-8 md:mt-12 flex flex-wrap items-center gap-3 md:gap-4">
              <Link to="/contatti" className="btn-pill" data-testid="hero-cta-primary">
                {t("home.hero.cta1")}
                <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.6} />
              </Link>
              <Link to="/servizi" className="btn-ghost" data-testid="hero-cta-secondary">
                {t("home.hero.cta2")}
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="relative aspect-square w-full max-w-[420px] lg:max-w-[560px] mx-auto">
            <div
              aria-hidden="true"
              className="absolute inset-0 rounded-full"
              style={{
                background:
                  "radial-gradient(circle at 30% 30%, rgba(18,18,18,0.06), transparent 55%)",
              }}
            />
            <Hero3D className="absolute inset-0" />
          </div>
        </div>
      </div>

      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage:
            "radial-gradient(rgba(18,18,18,0.04) 1px, transparent 1px)",
          backgroundSize: "3px 3px",
        }}
      />
    </section>
  );
};
